<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        //trocar id para code depois que vier a coluna
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Nome", align: "left", sortable: true, value: "name" },
        // { text: "Status", align: "left", sortable: true, value: "statusText", filter_value: "status" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        // { field: 'price', mask: 'currency'},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Motivo de Perda em Ciclo"
    },
    modelNamePlural: {
      type: String,
      default: "Motivos de Perdas em Ciclos"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete
  },
  created() {
    // this.loadServerEntries();
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_PERIOD_LOSS_REASONS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.indexItems = response.data.accountContext.periodLossReasonsIndex.periodLossReasons; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.accountContext.periodLossReasonsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.periodLossReasonsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.periodLossReasonsIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const LOAD_ALL_PERIOD_LOSS_REASONS = gql `
  query($input: IndexInputObject!) {
    accountContext {
      periodLossReasonsIndex(input: $input){
        count
        typeOperators
        serverFields      
        periodLossReasons {
          id
          code
          name
          description
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`;

</script>

<style scoped></style>
